import { INIT, SEND, SEND_SUCCESS, SEND_FAILED } from './constants';

export const initAction = (deed) => ({
  type: INIT,
  deed,
});

export const sendAction = (subject, message, fromName, fromEmail, deed) => ({
  type: SEND,
  subject,
  message,
  fromName,
  fromEmail,
  deed,
});
export const sendSuccessAction = () => ({ type: SEND_SUCCESS });
export const sendFailedAction = (error, errorCode) => ({
  type: SEND_FAILED,
  error,
  errorCode,
});
